export enum Feedback {
    SUCCESS = "success",
    ERROR = "error",
    DELETE = "delete",
    SUBSTITUDE = "substitude",
    INCOMPLETE = "incomplete"
}
